export default __webpack_public_path__ + "static/media/detail_main_img_16.ce1abfdd.png";